import $x from '@/utils/$x';

/**
 * save
 * @param {*} params
 * @returns
 */
export async function saveActivity(params) {
  return $x.post('/litta/reward/activity/save', params);
}

/**
 * 奖励活动列表
 * @param {*} params
 * @returns
 */
export async function listActivity(params) {
  return $x.post('/litta/reward/activity/list', params);
}

/**
 * 删除奖励活动
 * @param {*} params
 * @returns
 */
export async function deleteActivity(params) {
  return $x.post('/litta/reward/activity/delete', params);
}

/**
 * 查询奖励活动
 * @param {*} params
 * @returns
 */
export async function findByIdActivity(params) {
  return $x.post('/litta/reward/activity/findById', params);
}

/**
 * 奖励活动-上下架
 * @param {*} params
 * @returns
 */
export async function onlineOrOffLineActivity(params) {
  return $x.post('/litta/reward/activity/onlineOrOffLine', params);
}

/**
 * 活动链接列表
 * @param {*} params
 * @returns
 */
export async function channelList(params) {
  return $x.post('/v1/litta/channel/list', params);
}

/**
 * 下载小程序码
 * @param {*} params
 * @returns
 */
export async function downloadWXCode(params) {
  return $x.post('/litta/reward/activity/get-dm-applet-code', params);
}
